import { render, staticRenderFns } from "./CheckoutPurchase.vue?vue&type=template&id=9854dfea"
import script from "./CheckoutPurchase.vue?vue&type=script&lang=js"
export * from "./CheckoutPurchase.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPurchase.vue?vue&type=style&index=0&id=9854dfea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports